// extracted by mini-css-extract-plugin
export default {"stackWrapper":"LsV2jedM6nie_A3lw_nA"};